var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar-chart-container",staticStyle:{"background":"none"}},[_c('v-chart',{staticStyle:{"background":"yellow"},attrs:{"options":_vm.option,"autoresize":true,"id":"bar-chart"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }